import { useState } from 'react'

export const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState<string | null>(null)

  const copy = async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported')
    }
    try {
      await navigator.clipboard.writeText(text)
      setCopiedText(text)
    } catch (error) {
      console.warn('Copy failed', error)
      setCopiedText(null)
    }
  }

  return { copiedText, copy }
}

export default useCopyToClipboard
